import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUpcomingAppointments } from '../utilFunctions/getUpcomingAppointments';

const isWithinBufferTime=(appointment)=> {
  const appointmentDate = new Date(appointment.apptDateString);
  const currentTime = new Date();

  const diffInMs = currentTime.getTime() - appointmentDate.getTime();
  const diffInHours = diffInMs / (1000 * 60 * 60);

  // return diffInHours >= -1 && diffInHours <= 5;
  return diffInHours <= 5;
}

// Define async thunks for fetching data from the APIs
export const fetchUpcommingAppointments = createAsyncThunk('api/upcommingAppointment', async () => {
  const list = await getUpcomingAppointments();
  // filter and dont show the appointment which is not in the buffer time of 1hr
  const filteredList = list.filter(appointment => isWithinBufferTime(appointment));
  return filteredList;
});


// Create the slice
const appointmentSlice = createSlice({
  name: 'appointments',
  initialState: {
    bookedAppointments: null,
    selectedAppontemnt:null,
    selectedManageAppointment:null,
    surveyAppointment:null,
    selectedVital:null,
    status: 'idle',
    error: null,
    patientCount:null,
  },
  reducers: {
    updateSelectedAppontemnt: (state, action) => {
      state.selectedAppontemnt = action.payload;
    },
    updateSelectManageAppontemnt: (state, action) => {
      state.selectedManageAppointment = action.payload;
    },
    updateSurveyAppontemnt: (state, action) => {
      state.surveyAppointment = action.payload;
    },
    updateSelectVital: (state, action) => {
      state.selectedVital = action.payload;
    },
    updatePatientCount: (state, action) => {
      state.patientCount = action.payload;
    },

  },
  extraReducers: (builder) => {
    // Handle fetchApiOne
    builder
      .addCase(fetchUpcommingAppointments.pending, (state) => {
        state.statusOne = 'loading';
      })
      .addCase(fetchUpcommingAppointments.fulfilled, (state, action) => {
        state.statusOne = 'succeeded';
        state.bookedAppointments = action.payload;
      })
      .addCase(fetchUpcommingAppointments.rejected, (state, action) => {
        state.statusOne = 'failed';
        state.errorOne = action.error.message;
      })
  },
});

export const { updateSelectedAppontemnt, updateSelectManageAppontemnt, updateSelectVital, updateSurveyAppontemnt} = appointmentSlice.actions;

export const selectAppointments = (state) => state.appointments;
export const selectBookedAppointments = (state) => state.appointments.bookedAppointments;

export default appointmentSlice;
